import { getConfigValue } from 'utils/environment';

export { default as buildImageUrlUtil } from './build-image-url';

interface IGetSanityUrl {
  sanityDataset: string;
  useCdn?: boolean;
}

const getSanityBaseUrl = (useCdn: boolean = true) =>
  `https://${getConfigValue('sanityProjectId')}.api${useCdn ? 'cdn' : ''}.sanity.io/v1`;

export const getSanityGroqQueryUrl = ({ sanityDataset, useCdn }: IGetSanityUrl) =>
  `${getSanityBaseUrl(useCdn)}/data/query/${sanityDataset}`;

export const getSanityGraphqlQueryUrl = ({ sanityDataset, useCdn }: IGetSanityUrl) =>
  `${getSanityBaseUrl(useCdn)}/graphql/${sanityDataset}/default`;

export const getSanityGraphqlQueryUrlV2 = ({ sanityDataset, useCdn }: IGetSanityUrl) =>
  `${getSanityBaseUrl(useCdn)}/graphql/${sanityDataset}/gen2`;
